import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Navbar from './components/Navbar.js';
import Hero from './components/Hero.js';
import Highlights from './components/Highlights.js';
import Services from './components/Services.js';
import About from './components/About.js';
import WhyChooseUs from './components/WhyChooseUs.js';
import Process from './components/Process.js';
import Testimonials from './components/Testimonials.js';
import Contact from './components/Contact.js';
import NotFound from './components/NotFound.js';
import Footer from './components/Footer.js';
import { initScrollReveals } from './utils/animations.js';

const e = React.createElement;

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // Simple and robust native router supporting clean URLs (/services, /about, /contact) & 404 NotFound
  useEffect(() => {
    const seoMetaData = {
      home: {
        title: 'Vijay Solar Power | Sustainable Solar Energy Solutions in Coimbatore, Tamil Nadu',
        description: 'Vijay Solar Power provides premier rooftop residential, commercial, and industrial solar installations, net metering, hybrid battery systems, and solar maintenance in Coimbatore, Tamil Nadu.',
        canonical: 'https://vijaysolarpower.com/',
        robots: 'index, follow'
      },
      services: {
        title: 'Solar Services & Solutions | Vijay Solar Power Coimbatore',
        description: 'Explore residential solar rooftop systems, commercial arrays, grid-tied net metering, off-grid battery storage, and solar maintenance services by Vijay Solar Power.',
        canonical: 'https://vijaysolarpower.com/services',
        robots: 'index, follow'
      },
      about: {
        title: 'About Vijay Solar Power | Trusted Solar Installers in Tamil Nadu',
        description: 'Learn about Vijay Solar Power\'s 15+ years of excellence delivering high-performance rooftop solar installations and renewable energy solutions across Tamil Nadu.',
        canonical: 'https://vijaysolarpower.com/about',
        robots: 'index, follow'
      },
      contact: {
        title: 'Contact Vijay Solar Power | Get a Free Solar Consultation in Coimbatore',
        description: 'Get in touch with Vijay Solar Power experts in Coimbatore. Call +91 94448 33272 or request a free quote for your residential or commercial solar project.',
        canonical: 'https://vijaysolarpower.com/contact',
        robots: 'index, follow'
      },
      notfound: {
        title: 'Page Not Found | Vijay Solar Power',
        description: 'The requested page could not be found. Return to Vijay Solar Power homepage or explore our clean energy services.',
        canonical: 'https://vijaysolarpower.com/',
        robots: 'noindex, follow'
      }
    };

    const handleRouteChange = () => {
      const rawPath = window.location.pathname.replace(/^\//, '');
      const rawHash = window.location.hash.replace(/^#\/?/, '');
      const path = rawPath || rawHash || 'home';
      
      let route = 'home';
      if (['home', 'services', 'about', 'contact'].includes(path)) {
        route = path;
      } else if (path !== '') {
        route = 'notfound';
      }

      setCurrentPage(route);

      // Update Document Title & Meta Description dynamically for SEO
      const meta = seoMetaData[route] || seoMetaData.notfound;
      document.title = meta.title;

      const descTag = document.querySelector('meta[name="description"]');
      if (descTag) descTag.setAttribute('content', meta.description);

      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (canonicalTag) {
        canonicalTag.setAttribute('href', meta.canonical);
      }

      let robotsTag = document.querySelector('meta[name="robots"]');
      if (robotsTag) {
        robotsTag.setAttribute('content', meta.robots);
      }
      
      // Scroll back to the top of the new page
      window.scrollTo(0, 0);
      
      // Trigger scroll reveals for elements on the newly mounted page
      setTimeout(() => {
        initScrollReveals();
      }, 100);
    };

    // Initialize router and scroll observers on load
    handleRouteChange();

    window.addEventListener('popstate', handleRouteChange);
    window.addEventListener('hashchange', handleRouteChange);
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      window.removeEventListener('hashchange', handleRouteChange);
    };
  }, []);

  return e(React.Fragment, null,
    e(Navbar, { activePage: currentPage }),
    e('main', null,
      currentPage === 'home' && e(React.Fragment, null,
        e(Hero, null),
        e(Highlights, null),
        e(WhyChooseUs, null),
        e(Process, null),
        e(Testimonials, null)
      ),
      currentPage === 'services' && e(Services, null),
      currentPage === 'about' && e(About, null),
      currentPage === 'contact' && e(Contact, null),
      currentPage === 'notfound' && e(NotFound, null)
    ),
    e(Footer, null)
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  e(React.StrictMode, null,
    e(App, null)
  )
);
